import { LabelTape, type LabelTapeProps } from "./LabelTape";

export type RoomTapeProps = Omit<LabelTapeProps, "size">;

export function RoomTape(props: RoomTapeProps) {
  return <LabelTape size="lg" {...props} />;
}
